import { useTranslations } from "next-intl";
import { Tab } from "@/components/TabSearch";
import { ChannelSortType, ISubChannelTreeRes } from "@/api/home";
import { IMenuListItem } from "@/components/CommonDropdown/mIndex";


export default function useTabSearchHook (channelList: ISubChannelTreeRes[]) {
  const t = useTranslations();

  const tabs: Tab[] = [];
  const moreTabs: Tab[] = [];
  let tabSortFilterMap: Record<string, IMenuListItem[]> = {}
  
  // 添加tab
  const addTab = (list: Tab[], channel: { slug: string; name: string, orderRule: ChannelSortType[] }) => {
    list.push({
      key: channel.slug,
      tabName: channel.name,
      orderRule: channel.orderRule,
    });
  };
  
  
  channelList.forEach((channel, index) => {
    const { slug, name, order_rule } = channel;
    
    if (index <= 3) { // 展示三个tab，剩余的下拉菜单展示
      addTab(tabs, { slug, name, orderRule: order_rule });
    } else {
      addTab(moreTabs, { slug, name, orderRule: order_rule });
    }
  });

  tabSortFilterMap =( [...tabs, ...moreTabs].reduce((pre, cur) => {
    return {
      ...pre,
      [cur.key]: cur.orderRule.map(rule => ({
        key: rule,
        text: t(`channel_sort_${rule}`),
      }))
    }
  }, {}));

  return  {
    tabs,
    moreTabs,
    tabSortFilterMap,
  }
}